import { useEffect, useCallback } from 'react';

const useBrowserTabTitle = (title) => {
    const setBrowserTabTitle = useCallback((newTitle) => {
        document.title = newTitle + " | GNC Go";
    }, []);

    useEffect(() => {
        if (title !== undefined) {
            document.title = title + " | GNC Go";
        }
    }, [title]);

    return { setBrowserTabTitle };
};

export default useBrowserTabTitle;
